import { render, staticRenderFns } from "./CEmptyPanel.vue?vue&type=template&id=a4824f1c&"
import script from "./CEmptyPanel.vue?vue&type=script&lang=js&"
export * from "./CEmptyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports